import { MenuItem, Typography, withStyles } from '@material-ui/core';

import { Field } from 'formik';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { calculateEndDate, formatDateForInput } from 'utilities/common';

import { TextField, Checkbox, Select } from 'modules/intake/form';

import { defaultEndDate } from 'utilities/common';
import ColorIndicator from './colorIndicator.component';
import Colors from './colors';
import GlobalVisaInfoCard from '../authorizationIntake/globalVisaInfoCard.component';
import GlobalDestinationCard from '../authorizationIntake/globalDestinationCard.component';

const styles = () => ({

});

class GlobalForm extends PureComponent {
  render() {
    const { global, contacts, vendors, vendorContacts, handleBlur, handleChange, setFieldValue, rootPath, enumerations, isSubmitting, isReadOnly } = this.props;
    const activeOptions = (options) => (options || []).filter((option) => option.isActive !== false);

    return (
      <div className="form-group">
        <Typography gutterBottom variant="h3">Global</Typography>
            <div className="row">
                <Field
                    component={Checkbox}
                    type="checkbox"
                    name={`${rootPath}.didReview`}
                    value={global.didReview}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Verify policy guidance on trips and trip budget amounts"
                />
            </div>
              <div className="row">
                <Field
                  component={TextField}
                  name={`${rootPath}.globalEstStartDate`}
                  label="Estimated Start Date"
                  value={global.globalEstStartDate}
                  onChange={(e) => {
                    defaultEndDate(e.target.value, global.globalEstEndDate, `${rootPath}.globalEstEndDate`, setFieldValue);
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                  type="date"
                />
                <Field
                    component={TextField}
                    name={`${rootPath}.assignmentLength`}
                    label="Assignment Length"
                    value={global.assignmentLength}
                    onChange={(event) => {
                        handleChange(event);
                        const duration = event.target.value.replace(/\s+days$/i, '').replace(/,/g, '').trim();
                        const endDate = formatDateForInput(calculateEndDate(global.globalEstStartDate, duration));
                        if (endDate) {
                        this.props.setFieldValue(`${rootPath}.globalEstEndDate`, endDate);
                        }
                    }}
                    onBlur={handleBlur}
                    numeric
                    suffix=" Days"
                    />
                <Field
                  component={TextField}
                  name={`${rootPath}.globalEstEndDate`}
                  label="Estimated End Date"
                  value={global.globalEstEndDate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="date"
                />
                <ColorIndicator color={Colors.globalService} />
              </div>
              <div className="row">
                <Field
                    component={Select}
                    name={`${rootPath}.immigrationServiceProviderId`}
                    label="Immigration Service Provider"
                    value={global.immigrationServiceProviderId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    labelWidth={200}
                    fullWidth
                    >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {activeOptions(enumerations.immigrationServiceProviders).map((option) => (
                        <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>
                    ))}
                    </Field>
              </div>
              {global.visaInfos.length > 0 && (
              <div className="mt-2">
                <Typography variant="h4" gutterBottom>Visa/Immigration</Typography>
                {global.visaInfos.map((visaInfo, index) => (
                    <GlobalVisaInfoCard
                    key={visaInfo.intakeContactId}
                    visaInfo={visaInfo}
                    index={index}
                    contact={contacts.find((instance) => instance.id === visaInfo.intakeContactId)}
                    enumerations={enumerations}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    />
                ))}
                </div>
            )}
        <GlobalDestinationCard
          globalService={global}
          contacts={contacts}
          vendors={vendors}
          vendorContacts={vendorContacts}
          enumerations={enumerations}
          setFieldValue={setFieldValue}
          isSubmitting={isSubmitting}
          isReadOnly={isReadOnly}
        />
      </div>
    );
  }
}

GlobalForm.propTypes = {
  classes: PropTypes.object.isRequired,
  global: PropTypes.object.isRequired,
  contacts: PropTypes.array.isRequired,
  vendors: PropTypes.array.isRequired,
  vendorContacts: PropTypes.array.isRequired,
  enumerations: PropTypes.object.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  rootPath: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool,
};

export default compose(
  withStyles(styles),
)(GlobalForm);